import ArticleCard from '@/components/feature/ArticleCard';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.isFeatured);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">精选推荐</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featured.map((article) => (
            <ArticleCard key={article.id} article={article} variant="default" />
          ))}
        </div>
      </div>
    </section>
  );
}